import * as STD                            from '@emersya/mpa-std-lib';

import CM                from '@emersya/mpa-components-manager-lib';
import { InputButton }   from '@emersya/mpa-components-lib';

export interface IStandingPersonalizationTileComponentConfiguration extends InputButton.Configuration {
	SKU : string;
	component : string;
};

export class StandingPersonalizationTileComponent extends InputButton.Component {
	static override initialize() {
		super.initialize();
	};

	static override getInputEventSubType() {
		const parentClass = (<(typeof CM.Component) []> <any> STD.object.getInheritanceChainFromClass(this))[ 1 ];
		if (!parentClass) {
			throw STD.errors.library('Should inherits from Input Button');
		}
		return parentClass.type;
	};

	override async component_start(ev : STD.events.Event<any, any>) {
		await super.component_start(ev);
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IStandingPersonalizationTileComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = StandingPersonalizationTileComponent;
	export type Component = StandingPersonalizationTileComponent;
	export type Configuration = IStandingPersonalizationTileComponentConfiguration;
}
;
import manifestXMLSource from './StandingPersonalizationTile.xml';
import './StandingPersonalizationTile.scss';

CM.declare({
	id :       'standing-personalization-tile',
	type :     StandingPersonalizationTileComponent,
	manifest : manifestXMLSource
});
